import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNavigation.css';

const BottomNavigation = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    if (path === '/') {
      return currentPath === '/';
    }
    return currentPath.startsWith(path);
  };

  return (
    <nav className="bottom-navigation">
{/* 20.02.26 - Switched from Material Icons to emoji - no font dependency */}
<Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
        <span className="nav-icon">🏠</span>
        <span className="nav-label">Home</span>
      </Link>

      <Link to="/files" className={`nav-item ${isActive('/files') ? 'active' : ''}`}>
        <span className="nav-icon">📁</span>
        <span className="nav-label">Files</span>
      </Link>

      <Link to="/upload" className={`nav-item ${isActive('/upload') ? 'active' : ''}`}>
        <span className="nav-icon">⬆️</span>
        <span className="nav-label">Upload</span>
      </Link>

      <Link to="/more" className={`nav-item ${isActive('/more') ? 'active' : ''}`}>
        <span className="nav-icon">☰</span>
        <span className="nav-label">More</span>
      </Link>
    </nav>
  );
};

export default BottomNavigation;